module.exports = __webpack_public_path__ + "static/media/bbackpc.fb29de59.jpg";